import {
  ComplexPasswordRegex,
  JustEngNameRegex,
  JustEngPasswordRegex,
  mobileReg,
  MobileRegex,
  NationalCodeRegex,
  PasswordRegex,
  PostalCodeRegex,
  SpecialCharacter,
} from "tools/validations/ErrorHelper"
import {
  NOTTYPE,
  REQUIRED,
  UNMATCHPASSWORD,
  VALIDATEREQNUMBER,
  VALIDCOMPLEXREGEX,
  VALIDENGPASSWORD,
  VALIDLATINUSERNAME,
  VALIDMOBILE,
  VALIDNATIONALCODE,
  VALIDPOSTALCODE,
} from "tools/validations/RegexKeywords"
import * as Yup from "yup"

export const validationSchemaHub = () =>
  Yup.object({
    name: Yup.string().required(),
    selectHubCategory: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    selectParentHub: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    selectHubType: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    selectState: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    selectCity: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    locationStartDate: Yup.object().required(),
    lat: Yup.number().required(),
    lng: Yup.number().required(),
    // getPlaque: Yup.number().required(),
    // addressDetail: Yup.string().required(),
    addressLine: Yup.string().required(),
  })

export const validationSchemaTypeHub = () =>
  Yup.object({
    name: Yup.string().required(),
    code: Yup.number().required(),
  })

export const validationSchemaLable = () =>
  Yup.object().shape({
    selectHub: Yup.object().shape({
      text: Yup.string().required("الزامی می باشد"),
      id: Yup.string().required("الزامی می باشد"),
    }),
    requestType: Yup.object().shape({
      text: Yup.string().required("الزامی می باشد"),
      id: Yup.string().required("الزامی می باشد"),
    }),
    requestNo: Yup.string().required("الزامی می باشد"),
    requestDate: Yup.object().required(),
    requestedNumber: Yup.string().required("الزامی می باشد"),
  })

export const validationSchemaAllocateLable = () =>
  Yup.object().shape(
    {
      labelRequestDto: Yup.object().shape({
        selectHub: Yup.object().shape({
          text: Yup.string().required("الزامی می باشد"),
          id: Yup.string().required("الزامی می باشد"),
        }),
        requestType: Yup.object().shape({
          text: Yup.string().required("الزامی می باشد"),
          id: Yup.string().required("الزامی می باشد"),
        }),
        requestNo: Yup.string().required("الزامی می باشد"),
        requestDate: Yup.object().required(),
        // requestedNumber: Yup.string().required("الزامی می باشد"),
      }),

      start: Yup.string().required("الزامی می باشد"),
      end: Yup.string().required("الزامی می باشد"),

      selectHub: Yup.object().when("selectCustomer", (val: any) => {
        if (!val) {
          return Yup.object().shape({
            text: Yup.string().required("الزامی می باشد"),
            id: Yup.string().required("الزامی می باشد"),
          })
        } else {
          return Yup.object().shape({
            text: Yup.string().notRequired(),
            id: Yup.string().notRequired(),
          })
        }
      }),

      selectCustomer: Yup.object().when("selectHub", (val: any) => {
        if (val === true) {
          return Yup.string().required()
        } else {
          return Yup.string().notRequired()
        }
      }),
    },
    [
      ["selectHub", "selectCustomer"],
      ["selectCustomer", "selectHub"],
    ]
  )

export const validationSchemaEstesna = () =>
  Yup.object().shape({
    description: Yup.string().required(),
    errorType: Yup.string().required(),
  })

export const validationSchemaCancelTrip = () =>
  Yup.object().shape({
    vehicleNumber0: Yup.string().required(),
    vehicleNumber1: Yup.string().required(),
    vehicleNumber2: Yup.string().required(),
    vehicleNumber3: Yup.string().required(),
  })

export const validationSchemaEndTrip = () =>
  Yup.object().shape({
    endTime: Yup.string().required(),

    vehicleNumber0: Yup.string().required(),
    vehicleNumber1: Yup.string().required(),
    vehicleNumber2: Yup.string().required(),
    vehicleNumber3: Yup.string().required(),
  })

export const validationSchemaEnterBarandaz = () =>
  Yup.object().shape({
    barandaz: Yup.string().required(),
    date: Yup.object().required(),

    vehicleNumber0: Yup.string().required(),
    vehicleNumber1: Yup.string().required(),
    vehicleNumber2: Yup.string().required(),
    vehicleNumber3: Yup.string().required(),
  })

export const validationSchemaEnterDoor = () =>
  Yup.object().shape({
    date: Yup.object().required(),
    //  enterTime:Yup.string().required(),
    selectGate: Yup.object().shape({
      id: Yup.number().required(),
      text: Yup.string().required(),
    }),
    vehicleNumber0: Yup.string().required(),
    vehicleNumber1: Yup.string().required(),
    vehicleNumber2: Yup.string().required(),
    vehicleNumber3: Yup.string().required(),
  })

export const validationSchemaExitBarandaz = () =>
  Yup.object().shape({
    barandaz: Yup.string().required(),
    date: Yup.object().required(),
    vehicleNumber0: Yup.string().required(),
    vehicleNumber1: Yup.string().required(),
    vehicleNumber2: Yup.string().required(),
    vehicleNumber3: Yup.string().required(),
  })

export const validationSchemaExitDoor = () =>
  Yup.object().shape({
    date: Yup.object().shape({
      day: Yup.number().required(),
      month: Yup.number().required(),
      year: Yup.number().required(),
    }),
    selectGate: Yup.object().shape({
      id: Yup.string().required(),
      text: Yup.string().required(),
    }),

    vehicleNumber0: Yup.string().required(),
    vehicleNumber1: Yup.string().required(),
    vehicleNumber2: Yup.string().required(),
    vehicleNumber3: Yup.string().required(),
  })
export const validationSchemaServicePro = () =>
  Yup.object().shape({
    code: Yup.number().required(),
    name: Yup.string().required(),
    service: Yup.object().shape({
      id: Yup.string().required(),
      text: Yup.string().required(),
    }),
    // validDateFrom:Yup.object().required(),
    // validDateTo:Yup.object().required(),
  })

export const vendorValidation = () =>
  Yup.object().shape({
    name: Yup.string().required().label("نام شرکت"),
    code: Yup.string().required().label("کد شرکت"),
    nationalCode: Yup.number().required(),
    contactNumber: Yup.number().label("شماره تماس"),
  })

export const vehicleMakeValidation = () =>
  Yup.object().shape({
    name: Yup.string().required(),
    code: Yup.number().required(),
    weightCapacity: Yup.number().required(),
    volumeCapacity: Yup.number().required(),
    consignmentCapacity: Yup.number().required(),
    vendorSelect: Yup.object(),
    fuelTypeSelect: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
  })

export const vehicleValidation = () =>
  Yup.object().shape({
    selecttype: Yup.object().label("نوع وسیله نقلیه"),
    fleetTypeSelect: Yup.object().shape({
      text: Yup.string().required().label("نوع ناوگان"),
      id: Yup.string().required(),
    }),
    selectHub: Yup.object().shape({
      text: Yup.string().required().label("کد هاب"),
      id: Yup.string().required(),
    }),
    vehicleMakeSelect: Yup.object().shape({
      text: Yup.string().required().label("مدل وسیله نقلیه"),
      id: Yup.string().required(),
    }),
    vehicleNumber0: Yup.number().required(),
    vehicleNumber1: Yup.string().required(),
    volumeCapacity: Yup.number().required(),
    weightCapacity: Yup.number().required(),
    // fixedDriverId:Yup.string().required(),
  })

export const routeValidation = () =>
  Yup.object().shape({
    code: Yup.number().required().label("کد مسیر"),
    name: Yup.string().required().label("نام مسیر"),
    selectSourceHub: Yup.object().required().label("مبدا"),
    selectTargetHub: Yup.object().required().label("مقصد"),
    nodes: Yup.number().required().label("گره"),
    connections: Yup.array().of(
      Yup.object().shape({
        distanceFromPreviousHub: Yup.number().required(),
        distanceVariance: Yup.number().required(),
        transitTime: Yup.string().required(),
        timeStoppage: Yup.string().required(),
        selectHub: Yup.object().shape({
          text: Yup.string().required(),
          id: Yup.string().required(),
        }),
      })
    ),
  })

export const gateValidation = () =>
  Yup.object().shape({
    selectHub: Yup.object().shape({
      text: Yup.string().required().label("کد هاب"),
      id: Yup.string().required(),
    }),
    name: Yup.string().required().label("نام درب"),
    code: Yup.number().required().label("کد درب"),
  })

export const exceptionValidation = () =>
  Yup.object().shape({
    code: Yup.string().required(),
    type: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    serviceDeliveryCustomers: Yup.array(),
  })

export const validationSchemaSubTableTwo = () =>
  Yup.object().shape({
    // discountFrom: Yup.number().required(),
    // discountPercent: Yup.number().required(),
    // discountTo: Yup.number().required(),
  })

export const validationSchemaSubTableOne = () =>
  Yup.object().shape({
    // discountFrom: Yup.number().required(),
    // discountPercent: Yup.number().required(),
    // discountTo: Yup.number().required(),
  })

export const validationSchemaVehicleMove = () =>
  Yup.object().shape({
    licenseNo: Yup.string().required(),
    licenseDate: Yup.object().required(),
    validateFrom: Yup.object().required(),
    validateTo: Yup.object().required(),
    selectDestinationHub: Yup.object().required("اجباری است"),
  })

export const validationSchemaProductGroup = () =>
  Yup.object({
    name: Yup.string().required(),
    code: Yup.number().required(),
    description: Yup.string(),
  })

export const dockValidation = () =>
  Yup.object().shape({
    name: Yup.string().required().label("نام بارانداز"),
    code: Yup.number().required().label("کد بارانداز"),
    selectHub: Yup.object().shape({
      text: Yup.string().required().label("کد هاب"),
      id: Yup.string().required(),
    }),
  })

export const bagValidation = (isBulk, isEditBulk) =>
  Yup.object().shape({
    bagType: Yup.object().shape({
      text: Yup.string().required("الزامی است"),
      id: Yup.string().required("الزامی است"),
    }),
    bagNumber: !isBulk && !isEditBulk && Yup.string().required("الزامی است"),
    sourceHubId: Yup.object().shape({
      text: Yup.string().required("الزامی است"),
      id: Yup.string().required("الزامی است"),
    }),
    destinationHubId: Yup.object().shape({
      text: Yup.string().required("الزامی است"),
      id: Yup.string().required("الزامی است"),
    }),
    consignmentsDestinationHubId: Yup.object().shape({
      text: Yup.string().required("الزامی است"),
      id: Yup.string().required("الزامی است"),
    }),
    // carrierId: Yup.object().shape({
    //   text: Yup.string().required("الزامی است"),
    //   id: Yup.string().required("الزامی است"),
    // }),
    weightCapacity: Yup.string().required("الزامی است"),

    volumeCapacity: Yup.string().when("bagType", {
      is: (bagType) => bagType?.text === "کیسه",
      then: Yup.string(),
      otherwise: Yup.string().required("الزامی است"),
    }),
    bagClass:
      isBulk &&
      Yup.object().shape({
        text: Yup.string().required("الزامی است"),
        id: Yup.string().required("الزامی است"),
      }),
    bagNumberRange:
      isBulk &&
      Yup.object().shape({
        from: Yup.string().required("الزامی است"),
        to: Yup.string()
          .required("الزامی است")
          .test(
            "is-greater",
            "مقدار 'تا' باید بزرگتر یا مساوی مقدار 'از' باشد",
            function (value) {
              const { from } = this.parent
              if (!from || !value) return true
              return Number(value) >= Number(from)
            }
          ),
      }),
  })
export const productValidation = () =>
  Yup.object().shape({
    code: Yup.string().required("اجباری است"),
    name: Yup.string().required("اجباری است"),
    productGroup: Yup.object().shape({
      text: Yup.string().required("اجباری است"),
      id: Yup.string().required("اجباری است"),
    }),
  })

export const serviceDefineValidation = () =>
  Yup.object().shape({
    name: Yup.string().required("اجباری است"),
    code: Yup.string().required("اجباری است"),
    description: Yup.string().required("اجباری است"),
    minimumOrderQuantity: Yup.number(),
    type: Yup.object().shape({
      text: Yup.string().required("اجباری است"),
      id: Yup.string().required("اجباری است"),
    }),
    product: Yup.object().shape({
      text: Yup.string().required("اجباری است"),
      id: Yup.string().required("اجباری است"),
    }),
    priceList: Yup.object().shape({
      text: Yup.string().required("اجباری است"),
      id: Yup.string().required("اجباری است"),
    }),
  })

export const productInfoalidation = () =>
  Yup.object().shape(
    {
      fromSourceCity: Yup.array().when(
        "fromDestinationCity",
        (val: any, schema: any) => {
          if (val?.length > 0) {
            return Yup.array().required()
          } else {
            return Yup.array().notRequired()
          }
        }
      ),
      fromDestinationCity: Yup.array().when(
        "fromSourceCity",
        (val: any, schema: any) => {
          if (val?.length > 0) {
            return Yup.array().required()
          } else {
            return Yup.array().notRequired()
          }
        }
      ),
      fromDestinationLocation: Yup.array().when(
        "fromSourceLocation",
        (val: any, schema: any) => {
          if (val?.length > 0) {
            return Yup.array().required()
          } else {
            return Yup.array().notRequired()
          }
        }
      ),
      fromSourceLocation: Yup.array().when(
        "fromDestinationLocation",
        (val: any, schema: any) => {
          if (val) {
            return Yup.array().required()
          } else {
            return Yup.array().notRequired()
          }
        }
      ),
      fromCountryDevision: Yup.array(),
      toCountryDevision: Yup.array(),
      usingProduct: Yup.array(),
      timeCommitment: Yup.object().shape({
        text: Yup.string().required(),
        id: Yup.string().required(),
      }),
      product: Yup.object().shape({
        text: Yup.string().required(),
        id: Yup.string().required(),
      }),
      toWeight: Yup.number().min(0),
      fromWeight: Yup.number()
        .min(0)
        .when("toWeight", (val: any, schema: any) => {
          if (val?.length > 0) {
            return Yup.number().nullable().required()
          } else {
            return Yup.number().notRequired()
          }
        }),
      fromDim: Yup.number()
        .min(0)
        .when("toDimension", (val: any, schema: any) => {
          if (val?.length > 0) {
            return Yup.number().nullable().required()
          } else {
            return Yup.number().notRequired()
          }
        }),
      toDimension: Yup.number().min(0),
      fromValue: Yup.number()
        .min(0)
        // .ensure()
        .when("toValue", (val: any, schema: any) => {
          if (val?.length > 0) {
            return Yup.number().nullable().required()
          } else {
            return Yup.number().notRequired()
          }
        }),
      toValue: Yup.number().min(0),
    },
    [
      ["fromSourceLocation", "fromDestinationLocation"],
      ["fromSourceCity", "fromDestinationCity"],
      ["fromWeight", "toWeight"],
      ["toDimension", "fromDim"],
      ["fromValue", "toValue"],
    ]
  )

export const driverChangeStatusValidation = () =>
  Yup.object().shape({
    fromTime: Yup.array().of(
      Yup.object().shape({
        presenceAbsenceTimeFrom: Yup.string().required().label("اجباری است"),
      })
    ),
    toTime: Yup.array().of(
      Yup.object().shape({
        presenceAbsenceTimeTo: Yup.string().required().label("اجباری است"),
      })
    ),
    shift: Yup.array().of(
      Yup.object().shape({
        selectdispatchShift: Yup.array().of(
          Yup.object().shape({
            id: Yup.string().required(),
            text: Yup.string().required(),
          })
        ),
      })
    ),
  })

export const driverManagmentvalidation = () =>
  Yup.object().shape({
    selectHub: Yup.object().shape({
      text: Yup.string().required("اجباری است"),
      id: Yup.string().required("اجباری است"),
    }),
    startDate: Yup.object().required("اجباری است"),
    endDate: Yup.object().required("اجباری است"),
    drivingLicenceNumber: Yup.number().required("اجباری است"),
    drivingLicenseExpiry: Yup.object().required("اجباری است"),
    name: Yup.string().required("اجباری است"),
    mobile: Yup.number().required("اجباری است"),
  })

export const sampleShiftvalidation = () =>
  Yup.object().shape({
    selecthub: Yup.object().shape({
      text: Yup.string().required("اجباری است"),
      id: Yup.string().required("اجباری است"),
    }),
    year: Yup.object().shape({
      text: Yup.string().required("اجباری است"),
      id: Yup.string().required("اجباری است"),
    }),
    dispatchShiftType: Yup.object().shape({
      text: Yup.string().required("اجباری است"),
      id: Yup.string().required("اجباری است"),
    }),
    timeFrom: Yup.string(),
    timeTo: Yup.string(),
  })

export const addCaseShiftvalidation = () =>
  Yup.object().shape({
    timeFrom: Yup.string().required("اجباری است"),
    timeTo: Yup.string().required("اجباری است"),
  })
export const saleChannelValidation = () =>
  Yup.object().shape({
    name: Yup.string().required().label("نام شرکت"),
    code: Yup.string().required().label("کد شرکت"),
  })

export const validationAddPerson = () =>
  Yup.object().shape({
    personelCode: Yup.string().required(),
    nationalCode: Yup.string()
      .matches(NationalCodeRegex, VALIDNATIONALCODE)
      .required(),
    name: Yup.string().required(),
    mobile: Yup.string().matches(MobileRegex, VALIDMOBILE).required(),
    email: Yup.string().email(),
    username: Yup.string()
      .matches(JustEngNameRegex, VALIDLATINUSERNAME)
      .required(),
    password: Yup.string()
      .matches(ComplexPasswordRegex, VALIDCOMPLEXREGEX)
      .required(),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], UNMATCHPASSWORD)
      .required(),
    isSuperAdmin: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
  })
export const validationEditPerson = () =>
  Yup.object().shape({
    personelCode: Yup.string().required(),
    nationalCode: Yup.string()
      .matches(NationalCodeRegex, VALIDNATIONALCODE)
      .required(),
    name: Yup.string().required(),
    mobile: Yup.string().matches(MobileRegex, VALIDMOBILE).required(),
    email: Yup.string().email(),

    isSuperAdmin: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
  })

export const validationAddRole = () =>
  Yup.object().shape({
    name: Yup.string().required("این فیلد اجبرای است"),
  })

export const changePasswordValidation = () =>
  Yup.object().shape({
    oldPassword: Yup.string().required(),
    newPassword: Yup.string()
      .min(8)
      .matches(PasswordRegex, VALIDENGPASSWORD)
      .required(),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("newPassword"), null], UNMATCHPASSWORD)
      .required(),
  })

export const ADMVehicleFormValidation = () =>
  Yup.object().shape({
    vehicleNumber0: Yup.string().required(),
    vehicleNumber1: Yup.string().required(),
    vehicleNumber2: Yup.string().required(),
    vehicleNumber3: Yup.string().required(),
    dayToStartWork: Yup.object().shape({
      day: Yup.number().required(),
      month: Yup.number().required(),
      year: Yup.number().required(),
    }),
    dayToFinishWork: Yup.object().shape({
      day: Yup.number().required(),
      month: Yup.number().required(),
      year: Yup.number().required(),
    }),
    timeToStartWork: Yup.string().required(),
    timeToFinishWork: Yup.string().required(),
    selectHub: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    vehicleMakeSelect: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    volumeCapacity: Yup.number().required(),
    weightCapacity: Yup.number().required(),
    name: Yup.string(),
    code: Yup.string(),
    isActive: Yup.boolean(),
  })

export const personRole = () =>
  Yup.object().shape({
    name: Yup.string(),
    role: Yup.array().required("مقادیر نباید خالی باشد"),
  })
export const personRoleUser = () =>
  Yup.object().shape({
    users: Yup.array(),
    role: Yup.array().required("مقادیر نباید خالی باشد"),
  })

export const CustomerAddValidation = (customerTypeId: number | string) =>
  Yup.object().shape({
    // code: Yup.string().required(),
    name: Yup.string().required(),
    mobile: Yup.string()
      .matches(/^(09\d{9}|9\d{9})$/, VALIDMOBILE)
      .required(),
    selectCustomerType: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    selectParentCustomer: Yup.object().nullable(true).shape({
      text: Yup.string(),
      id: Yup.number(),
    }),
    email: Yup.string().email(),
    currentCredit: Yup.number(),
    creditLimit: Yup.number(),
    initialCredit: Yup.number(),
    username:
      customerTypeId === 0
        ? Yup.string().nullable(true)
        : Yup.string().required(),
    password:
      customerTypeId === 0
        ? Yup.string().nullable(true)
        : Yup.string()
            .min(8)
            .matches(JustEngPasswordRegex, VALIDENGPASSWORD)
            .required(),
    confirmPassword:
      customerTypeId === 0
        ? Yup.string().nullable(true)
        : Yup.string()
            .oneOf([Yup.ref("password"), null], UNMATCHPASSWORD)
            .required(),
    extendGlobalVirtualSeries: Yup.boolean().nullable(),
    dynamicPickupAllocation: Yup.boolean().nullable(),
    smsNotification: Yup.boolean().nullable(),
    emailNotification: Yup.boolean().nullable(),
    pickupPaperWithEmail: Yup.boolean().nullable(),
    isActive: Yup.boolean().nullable(),
    permissions: Yup.array()
      .of(
        Yup.object().shape({
          permissionTypeId: Yup.number()
            .typeError("نوع دسترسی باید عدد باشد")
            .required("نوع دسترسی الزامی است"),

          permissionValueId: Yup.number().required(),

          validFromDate: Yup.mixed().when("permissionValueId", {
            is: 0,
            then: (schema) =>
              Yup.object({
                day: Yup.string().required("روز الزامی است"),
                month: Yup.string().required("ماه الزامی است"),
                year: Yup.string().required("سال الزامی است"),
              }).required("تاریخ از الزامی است"),
            otherwise: (schema) => Yup.mixed().nullable().notRequired(),
          }),

          validToDate: Yup.mixed().when("permissionValueId", {
            is: 0,
            then: (schema) =>
              Yup.object({
                day: Yup.string().required("روز الزامی است"),
                month: Yup.string().required("ماه الزامی است"),
                year: Yup.string().required("سال الزامی است"),
              }).required("تاریخ تا الزامی است"),
            otherwise: (schema) => Yup.mixed().nullable().notRequired(),
          }),
        })
      )
      .notRequired()
      .default([]), 

    // postPaidValidFrom: Yup.object().when('withPostPaid', (val: any) => {
    //   if (val) {
    //     return Yup.object().shape({
    //       day: Yup.string().required(),
    //     })
    //   } else {
    //     return Yup.object().shape({
    //       day: Yup.string().notRequired(),
    //     })
    //   }
    // }),
    // postPaidValidTo: Yup.object().when('withPostPaid', (val: any) => {
    //   if (val) {
    //     return Yup.object().shape({
    //       day: Yup.string().required(),
    //     })
    //   } else {
    //     return Yup.object().shape({
    //       day: Yup.string().notRequired(),
    //     })
    //   }
    // }),
    // codValidFrom: Yup.object().when('withCod', (val: any) => {
    //   if (val) {
    //     return Yup.object().shape({
    //       day: Yup.string().required(),
    //     })
    //   } else {
    //     return Yup.object().shape({
    //       day: Yup.string().notRequired(),
    //     })
    //   }
    // }),
    // codValidTo: Yup.object().when('withCod', (val: any) => {
    //   if (val) {
    //     return Yup.object().shape({
    //       day: Yup.string().required(),
    //     })
    //   } else {
    //     return Yup.object().shape({
    //       day: Yup.string().notRequired(),
    //     })
    //   }
    // }),

    // isLaterPaidFromDate: Yup.object().when("isLaterPaid", (val: any) => {
    //   if (val) {
    //     return Yup.object().shape({
    //       day: Yup.string().required(),
    //     })
    //   } else {
    //     return Yup.object().shape({
    //       day: Yup.string().notRequired(),
    //     })
    //   }
    // }),
    // isLaterPaidToDate: Yup.object().when("isLaterPaid", (val: any) => {
    //   if (val) {
    //     return Yup.object().shape({
    //       day: Yup.string().required(),
    //     })
    //   } else {
    //     return Yup.object().shape({
    //       day: Yup.string().notRequired(),
    //     })
    //   }
    // }),
  })
export const CustomerEditValidation = (customerTypeId) =>
  Yup.object().shape({
    // code: Yup.string().required(),
    name: Yup.string().required(),
    mobile: Yup.number().required(),
    selectCustomerType: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    selectParentCustomer: Yup.object().nullable(true).shape({
      text: Yup.string(),
      id: Yup.number(),
    }),
    email: Yup.string().email(),
    currentCredit: Yup.number().nullable(),
    creditLimit: Yup.number().nullable(),
    initialCredit: Yup.number().nullable(),
    username:
      customerTypeId === 0
        ? Yup.string().nullable(true)
        : Yup.string().required(),
    extendGlobalVirtualSeries: Yup.boolean().nullable(),
    dynamicPickupAllocation: Yup.boolean().nullable(),
    smsNotification: Yup.boolean().nullable(),
    emailNotification: Yup.boolean().nullable(),
    pickupPaperWithEmail: Yup.boolean().nullable(),
    isActive: Yup.boolean().nullable(),
  })

export const CustomerAddressValidation = () =>
  Yup.object().shape({
    selectAddressType: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    selectCity: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    addressDetail: Yup.string().required(),
    postalCode: Yup.string()
      .matches(PostalCodeRegex, VALIDPOSTALCODE)
      .nullable(true),
    lat: Yup.string().required(),
    lng: Yup.string().required(),
    address: Yup.string().required(),
  })

export const TelephoneValidation = () =>
  Yup.object().shape({
    selectPhoneType: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    telNumber: Yup.number().required(),
    telephonePrefix: Yup.number().when("selectPhoneType", (val: any) => {
      if (val.id === "1") {
        return Yup.number().nullable(true)
      } else {
        return Yup.number().required()
      }
    }),
  })

export const ServiceTimeValidation = () =>
  Yup.object().shape({
    name: Yup.string().required(),
    from: Yup.number().min(0).required(),
    to: Yup.number()
      .min(0)
      .test(
        "isLarger",
        "باید از مقدار از بزرگتر باشد",
        (value, testContext) => {
          if (testContext.parent.from > value) return false
          return true
        }
      )
      .required(),
    isActive: Yup.boolean().nullable(),
    description: Yup.string().nullable(),
    selecttedtimeUnit: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
  })
// Yup.number().min(0).required()
export const ThirdPartyValidation = () =>
  Yup.object().shape({
    code: Yup.string().required(),
    name: Yup.string().required(),
    selectThirdPartyType: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    selectThirdPartyCategory: Yup.object().nullable(true).shape({
      text: Yup.string(),
      id: Yup.number(),
    }),
    selectParentThirdParty: Yup.object().nullable(true).shape({
      text: Yup.string(),
      id: Yup.number(),
    }),
    email: Yup.string().email(),
    isActive: Yup.boolean().nullable(),
  })

export const AddressValidation = () =>
  Yup.object().shape({
    selectCity: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    postalCode: Yup.string()
      .matches(PostalCodeRegex, VALIDPOSTALCODE)
      .nullable(true),
    addressDetail: Yup.string().required("جزیئات را پر کنید."),
    lat: Yup.string().required("موقعیت مکانی را روی نقشه مشخص کنید"),
    lng: Yup.string().required("موقعیت مکانی را روی نقشه مشخص کنید"),
    address: Yup.string().required(),
    staticAddress: Yup.string().notRequired(),
  })

export const NewAddressValidation = (isPost, isDifficult) =>
  Yup.object().shape({
    selectCity: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    postalCode: Yup.string()
      .matches(PostalCodeRegex, VALIDPOSTALCODE)
      .nullable(true),
    // addressDetail: isPost
    //   ? Yup.string().nullable(true)
    //   : Yup.string().required("جزیئات را پر کنید."),
    lat: !isPost && Yup.string().required("موقعیت مکانی را روی نقشه مشخص کنید"),
    lng: !isPost && Yup.string().required("موقعیت مکانی را روی نقشه مشخص کنید"),
    address: isPost ? Yup.string().nullable(true) : Yup.string().required(),
    staticAddress: Yup.string().notRequired(),
    contactAddress: isDifficult && Yup.string().min(10).required(),
  })

export const PriceValidation = () =>
  Yup.object().shape({
    priceListCode: Yup.number().required(),
    priceListName: Yup.string().required(),
    priceListDate: Yup.object().required(),
    validDateFrom: Yup.object().required(),
    validDateTo: Yup.object().required(),
  })

export const PriceAttributeValidation = () =>
  Yup.object().shape(
    {
      product: Yup.object().shape({
        id: Yup.string().required(),
      }),
      isParametric: Yup.boolean(),
      fromCountryDevision: Yup.string()
        .ensure()
        .when("categoryType", (val: any) => {
          if (val?.id === "0") {
            return Yup.array().min(1, REQUIRED).required()
          } else {
            return Yup.array().nullable(true)
          }
        }),
      toCountryDevision: Yup.string()
        .ensure()
        .when("categoryType", (val: any) => {
          if (val?.id === "0") {
            return Yup.array().min(1, REQUIRED).required()
          } else {
            return Yup.array().nullable(true)
          }
        }),

      fromSourceCity: Yup.array().when(
        "fromDestinationCity",
        (val: any, schema: any) => {
          if (val?.length > 0) {
            return Yup.array().required()
          } else {
            return Yup.array().notRequired()
          }
        }
      ),
      fromDestinationCity: Yup.array().when(
        "fromSourceCity",
        (val: any, schema: any) => {
          if (val?.length > 0) {
            return Yup.array().required()
          } else {
            return Yup.array().notRequired()
          }
        }
      ),
      // fromDestinationLocation: Yup.array().when(
      //   "fromSourceLocation",
      //   (val: any) => {
      //     if (val?.length > 0) {
      //       return Yup.array().required();
      //     } else {
      //       return Yup.array().notRequired();
      //     }
      //   }
      // ),
      // fromSourceLocation: Yup.array().when(
      //   "fromDestinationLocation",
      //   (val: any) => {
      //     if (val) {
      //       return Yup.array().required();
      //     } else {
      //       return Yup.array().notRequired();
      //     }
      //   }
      // ),
      categoryType: Yup.bool().when("isParametric", (val: any) => {
        if (val === false) {
          return Yup.object().shape({
            id: Yup.string().required(),
          })
        } else
          return Yup.object().nullable().shape({
            id: Yup.string().nullable(),
          })
      }),
      customDevision: Yup.object().when(["isParametric", "categoryType"], {
        is: (isParametric: any, categoryType: any) =>
          isParametric === false && categoryType.id === "1",
        then: Yup.object().shape({
          id: Yup.string().required(),
        }),
      }),
      price: Yup.number()
        .min(0)
        .when("fixedPrice", {
          is: false,
          then: Yup.number().nullable(true).default(null).required(),
        }),
      fromWeight: Yup.number().min(0).nullable(true),
      toWeight: Yup.number().min(0).max(25).nullable(true),
      fromValue: Yup.number().min(0).nullable(true),
      toValue: Yup.number().min(0).nullable(true),
      fromNumber: Yup.number().min(0).nullable(true),
      toNumber: Yup.number().min(0).nullable(true),
    },
    [
      ["fromSourceCity", "fromDestinationCity"],
      // ["fromSourceLocation", "fromDestinationLocation"],
      ["fromWeight", "isParametric"],
      ["toWeight", "isParametric"],
      ["fromNumber", "isParametric"],
      ["toNumber", "isParametric"],
      ["isParametric", "toValue"],
      ["isParametric", "fromValue"],
      ["price", "fixedPrice"],
    ]
  )

export const AssignmentValidation = () =>
  Yup.object().shape({
    selectfirsdriver: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
  })

export const ConsignmentDetailsValidation = (type: any) =>
  type === 2
    ? Yup.object().shape({
        declarativeWeight: Yup.number()
          .max(25)
          .required()
          .test("Is positive?", VALIDATEREQNUMBER, (value) => value > 0),
      })
    : Yup.object().shape({
        selectContent: Yup.object().shape({
          text: Yup.string().required(),
          id: Yup.string().required(),
        }),
        content: Yup.object().when("selectContent", (val: any) => {
          if (val.id === "0")
            return Yup.object().shape({
              id: Yup.string().nullable(true),
            })
          else
            return Yup.object().shape({
              text: Yup.string().required(),
              id: Yup.string().required(),
            })
        }),
        contentofOthers: Yup.object().when("content", (val: any) => {
          if (val?.id === "21") return Yup.string().required()
          else return Yup.string().nullable(true)
        }),

        declarativeLength: Yup.number()
          .required()
          .max(100)
          .test("Is positive?", VALIDATEREQNUMBER, (value) => value > 0),
        declarativeWidth: Yup.number()
          .required()
          .max(100)
          .test("Is positive?", VALIDATEREQNUMBER, (value) => value > 0),
        declarativeHeight: Yup.number()
          .required()
          .max(100)
          .test("Is positive?", VALIDATEREQNUMBER, (value) => value > 0),
        declarativeWeight: Yup.number()
          .required()
          .max(25)
          .test("Is positive?", VALIDATEREQNUMBER, (value) => value > 0),
        numberOfPieces: Yup.object().when("selectContent", (val: any) => {
          if (val.id === "0") return Yup.string().nullable(true)
          else
            return Yup.number()
              .required()
              .test("Is positive?", VALIDATEREQNUMBER, (value) => value > 0)
        }),
        declarativeValue: Yup.number()
          .required()
          .test("Is positive?", VALIDATEREQNUMBER, (value) => value > 0),
        costOfGoods: Yup.number().when(
          "needToReciveCostOfGoods",
          (val: any) => {
            if (val === false) {
              return Yup.number().nullable()
            } else {
              return Yup.number()
                .required()
                .test("Is positive?", VALIDATEREQNUMBER, (value) => value > 0)
            }
          }
        ),

        typeOfPackage: Yup.object().shape({
          text: Yup.string().required(),
          id: Yup.string().required(),
        }),

        // typeOfPackage: Yup.number().when("needToPack", (val: any) => {
        //   if (val === false) {
        //     return Yup.number().nullable();
        //   } else {
        //     return Yup.object().shape({
        //       id: Yup.string().required(),
        //     });
        //   }
        // }),
      })

export const RecieverCustomerValidation = () =>
  Yup.object().shape({
    name: Yup.string().trim().min(2).required(),
    mobile: Yup.string().required(),
  })
export const RecieverMobileValidation = () =>
  Yup.object().shape({
    telNumber: Yup.string().required(),
  })

export const EditCustomerPhoneValidation = () =>
  Yup.object().shape({
    telNumber: Yup.number().required(),
  })

export const createTripValidation = () =>
  Yup.object().shape({
    selectdestinationHub: Yup.object().when("triptype", (val: any) => {
      if (val.id === "3") {
        return Yup.object().shape({
          text: Yup.string().required(),
          id: Yup.string().required(),
        })
      } else {
        return Yup.object().shape({
          id: Yup.string().nullable(true),
        })
      }
    }),
    selectRoute: Yup.object().when("triptype", (val: any) => {
      if (val.id === "3") {
        return Yup.object().shape({
          text: Yup.string().required(),
          id: Yup.string().required(),
        })
      } else {
        return Yup.object().shape({
          id: Yup.string().nullable(true),
        })
      }
    }),
    selectdispatchShift: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    triptype: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    loading: Yup.string().required(),
    capacityCompletionPercentage: Yup.string().required(),
    vehiclePlanDate: Yup.object().shape({
      year: Yup.number().required(),
      month: Yup.number().required(),
      day: Yup.number().required(),
    }),
  })

export const CreateNewTripValidation = () =>
  Yup.object().shape({
    vehicleNumber0: Yup.string().required(),
    vehicleNumber1: Yup.string().required(),
    vehicleNumber2: Yup.string().required(),
    vehicleNumber3: Yup.string().required(),
    vehicleMakeSelect: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    selectdestinationHub: Yup.object().when("triptype", (val: any) => {
      if (val.id === "3") {
        return Yup.object().shape({
          text: Yup.string().required(),
          id: Yup.string().required(),
        })
      } else {
        return Yup.object().shape({
          id: Yup.string().nullable(true),
        })
      }
    }),
    selectRoute: Yup.object().when("triptype", (val: any) => {
      if (val.id === "3") {
        return Yup.object().shape({
          text: Yup.string().required(),
          id: Yup.string().required(),
        })
      } else {
        return Yup.object().shape({
          id: Yup.string().nullable(true),
        })
      }
    }),
    driver: Yup.string().required(),
    mobile: Yup.number().required(),
    drivingLicenceNumber: Yup.number().required(),
    selectdispatchShift: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    triptype: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    loading: Yup.string().required(),
    capacityCompletionPercentage: Yup.string().required(),
    drivingLicenseExpiry: Yup.object().shape({
      year: Yup.number().required(),
      month: Yup.number().required(),
      day: Yup.number().required(),
    }),
    vehiclePlanDate: Yup.object().shape({
      year: Yup.number().required(),
      month: Yup.number().required(),
      day: Yup.number().required(),
    }),
  })

export const RecoveryValidation = () =>
  Yup.object().shape({
    password: Yup.string()
      .min(8)
      .matches(JustEngPasswordRegex, VALIDENGPASSWORD)
      .required(),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], UNMATCHPASSWORD)
      .required(),
  })

export const ForgotPasswordValidation = () =>
  Yup.object().shape({
    username: Yup.string().required(),
  })

export const DeliveryRegionAllocatedValidation = () =>
  Yup.object().shape({
    selectRegion: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
  })

export const CheckCityValidation = () =>
  Yup.object().shape({
    selectCity: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
  })
export const validationpinCode = Yup.object().shape({})
export const validationAddEditCrmManagement = Yup.object().shape({
  name: Yup.string().required(),
  code: Yup.string().required(),
  selectcustomer: Yup.array(),
})
export const validationTitle = Yup.object().shape({
  name: Yup.string().required(),
  code: Yup.number().required(),
})

export const validationGeowrapper = Yup.object().shape(
  {
    fromCountryDevision: Yup.array().required(),
    toCountryDevision: Yup.array().required(),

    fromSourceCity: Yup.array().when("fromDestinationCity", (val: any) => {
      if (val?.length > 0) {
        return Yup.array().required()
      } else {
        return Yup.array().notRequired()
      }
    }),
    fromDestinationCity: Yup.array().when("fromSourceCity", (val: any) => {
      if (val?.length > 0) {
        return Yup.array().required()
      } else {
        return Yup.array().notRequired()
      }
    }),
    fromDestinationLocation: Yup.array().when(
      "fromSourceLocation",
      (val: any) => {
        if (val?.length > 0) {
          return Yup.array().required()
        } else {
          return Yup.array().notRequired()
        }
      }
    ),
    fromSourceLocation: Yup.array().when(
      "fromDestinationLocation",
      (val: any) => {
        if (val) {
          return Yup.array().required()
        } else {
          return Yup.array().notRequired()
        }
      }
    ),
  },
  [
    ["fromSourceLocation", "fromDestinationLocation"],
    ["fromSourceCity", "fromDestinationCity"],
  ]
)
export const geowrapperEdittitle = () =>
  Yup.object().shape({
    name: Yup.string().required(),
    code: Yup.number().required(),
  })

export const validationlocationForm = () =>
  Yup.object().shape(
    {
      fromCountryDevision: Yup.array().required(),
      toCountryDevision: Yup.array().required(),

      fromSourceCity: Yup.array().when("fromDestinationCity", (val, schema) => {
        if (val?.length > 0) {
          return Yup.array().required()
        } else {
          return Yup.array().notRequired()
        }
      }),
      fromDestinationCity: Yup.array().when("fromSourceCity", (val, schema) => {
        if (val?.length > 0) {
          return Yup.array().required()
        } else {
          return Yup.array().notRequired()
        }
      }),
      fromDestinationLocation: Yup.array().when(
        "fromSourceLocation",
        (val: any, schema: any) => {
          if (val?.length > 0) {
            return Yup.array().required()
          } else {
            return Yup.array().notRequired()
          }
        }
      ),
      fromSourceLocation: Yup.array().when(
        "fromDestinationLocation",
        (val: any, schema: any) => {
          if (val) {
            return Yup.array().required()
          } else {
            return Yup.array().notRequired()
          }
        }
      ),
    },
    [
      ["fromSourceLocation", "fromDestinationLocation"],
      ["fromSourceCity", "fromDestinationCity"],
    ]
  )
export const valicationCreateEditZone = () =>
  Yup.object().shape({
    code: Yup.string().required(),
    name: Yup.string().required(),
    countrytype: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    employee: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
  })
export const valicationCreateHubzoneInfoForm = () =>
  Yup.object().shape({
    code: Yup.string().required(),
    name: Yup.string().required(),
    countrytype: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    employee: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
  })
export const valicationCreateEdizoneForm = () =>
  Yup.object().shape({
    code: Yup.string().required(),
    name: Yup.string().required(),
  })

export const ConsignmentsPaymentValidation = () =>
  Yup.object().shape({
    consignments: Yup.array().of(
      Yup.object().shape({
        payBy: Yup.string().required(),
      })
    ),
  })

export const programmingValidation = () =>
  Yup.object().shape({
    selectHub: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    pickupShift: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    mdlShift: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    selectVehicle: Yup.array().required(),
    mdlVehicle: Yup.array().required(),
  })

export const planingValidation = () =>
  Yup.object().shape({
    selectHub: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    pickupShift: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    mdlShift: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
  })

export const assignVehiclePlaningValidation = () =>
  Yup.object().shape({
    pudoVehicleId: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
  })

export const deliveredModalValidation = Yup.object({
  // deliveryPersonName: Yup.string().required(
  //   "وارد کردن نام و نام خانوادگی الزامی است."
  // ),
  // deliveryPersonNationalCode: Yup.string()
  //   .matches(NationalCodeRegex, VALIDNATIONALCODE)
  //   .required("وارد کردن کد ملی الزامی است"),
  // deliveryPersonMobile: Yup.string().required(
  //   "وارد کردن شماره موبایل الزامی است"
  // ),
  deliveryCode: Yup.string().when("isOrganize", {
    is: false,
    then: Yup.string().required("الزامی است"),
    otherwise: Yup.string().notRequired(),
  }),
})

export const addOrderValidation = (hasSneder,editMode) =>
  Yup.object({
    receiver: Yup.object().shape({
      name: Yup.string()
        .trim()
        .min(2)
        .matches(SpecialCharacter, NOTTYPE)
        .required(),
      mobile: Yup.string().matches(mobileReg, NOTTYPE).required(),
      receiverCityId: Yup.object().shape({
        text: Yup.string().required(),
        id: Yup.string().required(),
      }),
      address: Yup.string()
        .trim()
        .min(20)
        .matches(SpecialCharacter, NOTTYPE)
        .required(),
    }),

    sender:
      !hasSneder &&
      Yup.object().shape({
        name: Yup.string()
          .trim()
          .min(2)
          .matches(SpecialCharacter, NOTTYPE)
          .required(),
        // nationalCode: Yup.string().required(),
        mobile: Yup.string().matches(mobileReg, NOTTYPE).required(),
      }),
    width: Yup.number().required(),
    height: Yup.number().required(),
    length: Yup.number().required(),


weight: !!editMode 
  ? (editMode.weight > 15 
      ? Yup.number().oneOf([editMode.weight], 'وزن‌های بالای ۱۵ قابل ویرایش نیستند').required()
      : Yup.number().min(0).max(20).required() 
    )
  : Yup.number().min(0).max(20).required(),
    cprNumber: Yup.number().required(),
    contentType: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    packageId: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    extraCosts: Yup.number().max(5000000).nullable(),
    value: Yup.number()
      // .required('این فیلد الزامی است')
      .when("insurance", {
        is: (insurance) => insurance?.id === 1,
        then: (schema) => schema.required("این فیلد الزامی است"),
        otherwise: (schema) => schema.notRequired(),
      })
      .test(
        "max-based-on-conditions",
        "مقدار وارد شده معتبر نیست",
      function (value) {
          const { insurance, consignmentType, contentType } = this.parent
          // if (insurance?.id === 1 && value > 200000000) {
          //   return this.createError({
          //     message: 'هزینه کالا بالای ۲۰۰,۰۰۰,۰۰۰ ریال نمی‌تواند باشد',
          //   })
          // }
          if (
            // +consignmentType?.id === 0 &&
            // +contentType?.id === 0 &&
            value > 500000000
          ) {
            return this.createError({
              message:
                "هزینه کالا برای این نوع مرسوله نمی‌تواند بالای ۵۰۰,۰۰۰,۰۰۰ ریال باشد",
            })
          }
          return true
        }
      ),
    costOfGoods: Yup.object().when("cod", (val: any) => {
      if (val === true) {
        return Yup.number().required()
      } else {
        return Yup.number().notRequired()
      }
    }),

    // messageForDriver: Yup.string().min(20),
  })

export const postDelieveryValidation = () =>
  Yup.object().shape({
    selectHub: Yup.object().shape({
      id: Yup.string(),
      text: Yup.string().required("اجباری است"),
    }),
    fromDate: Yup.object().shape({
      day: Yup.string().required(),
      month: Yup.string().required(),
      year: Yup.string().required(),
    }),
    toDate: Yup.object().shape({
      day: Yup.string().required(),
      month: Yup.string().required(),
      year: Yup.string().required(),
    }),
  })

export const postDelieveryByScanValidation = () =>
  Yup.object().shape({
    selectHub: Yup.object().shape({
      id: Yup.string(),
      text: Yup.string().required("اجباری است"),
    }),
  })
export const changeDriverValidation = () =>
  Yup.object().shape({
    selectHub: Yup.object().shape({
      id: Yup.string(),
      text: Yup.string().required("اجباری است"),
    }),
    selectTripType: Yup.object().shape({
      id: Yup.string(),
      text: Yup.string().required("اجباری است"),
    }),
    tripNo: Yup.object().shape({
      id: Yup.string(),
      text: Yup.string().required("اجباری است"),
    }),
    selectDriver: Yup.object().shape({
      id: Yup.string(),
      text: Yup.string().required("اجباری است"),
    }),
  })

export const consignmentAddressValidation = () =>
  Yup.object().shape({
    selectCity: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    postalCode: Yup.string()
      .matches(PostalCodeRegex, VALIDPOSTALCODE)
      .nullable(true),
    addressDetail: Yup.string().required("جزیئات را پر کنید."),
    lat: Yup.string().required("موقعیت مکانی را روی نقشه مشخص کنید"),
    lng: Yup.string().required("موقعیت مکانی را روی نقشه مشخص کنید"),
    address: Yup.string().notRequired(),
    staticAddress: Yup.string().notRequired(),
  })

export const creditValidation = () =>
  Yup.object().shape({
    amount: Yup.number().min(0).required(),
  })

export const orderReceiptValidate = () =>
  Yup.object().shape({
    nationalCode: Yup.string().required(),
    name: Yup.string().required(),
    mobile: Yup.string().required(),
    count: Yup.string().required(),
  })

export const deliveryGroupValidate = () =>
  Yup.object().shape({
    selectDriver: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    dispatchShiftId: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),

    // dayToStartWork: Yup.object().shape({
    //   day: Yup.number().required(),
    //   month: Yup.number().required(),
    //   year: Yup.number().required(),
    // }),
    deliveryTime: Yup.string().required(),
  })
export const deliveryGroupPrintValidate = () =>
  Yup.object().shape({
    // selectDriver:Yup.array().required("اجباری است"),
    selectDriver: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),

    deliveryTime: Yup.string().required(),
  })

export const defineTerminalValidation = () =>
  Yup.object().shape({
    terminalNo: Yup.string().required(),
    hubId: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    // employeeId: Yup.object().shape({
    //   text: Yup.string().required(),
    //   id: Yup.string().required(),
    // }),
    isActive: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
  })

export const allocateHubCredit = () =>
  Yup.object().shape({
    maxCredit: Yup.number().required(),
  })
export const addressCorrectionFilter = () =>
  Yup.object().shape({
    createdDateDto: Yup.object().shape({
      day: Yup.number().required(),
      month: Yup.number().required(),
      year: Yup.number().required(),
    }),
    selectState: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    selectCity: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
  })

export const userInputPrice = () =>
  Yup.object().shape({
    usedCredit: Yup.number().min(0).required(),
  })

export const OTPMobile = () =>
  Yup.object().shape({
    mobile: Yup.string().matches(mobileReg, NOTTYPE).required(),
  })

export const detailShift = () =>
  Yup.object().shape({
    timeFrom: Yup.object().shape({
      day: Yup.number().required(),
      month: Yup.number().required(),
      year: Yup.number().required(),
    }),
    timeTo: Yup.object().shape({
      day: Yup.number().required(),
      month: Yup.number().required(),
      year: Yup.number().required(),
    }),
    hubId: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    regionId: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    shiftList: Yup.array()
      .min(1, "حداقل یک شیفت باید انتخاب شود")
      .required("انتخاب شیفت الزامی است"),

    detailList: Yup.array().of(
      Yup.object().shape({
        capacity: Yup.string().required(),
        price: Yup.number().required(),
        vehicleType: Yup.object().shape({
          text: Yup.string().required(),
          id: Yup.string().required(),
        }),
      })
    ),
  })

export const allocateShift = () =>
  Yup.object().shape({
    driverList: Yup.array()
      .min(1, "حداقل یک راننده باید انتخاب شود")
      .required("انتخاب راننده الزامی است"),
  })

export const fishValidation = () =>
  Yup.object().shape({
    receiptNo: Yup.string().required(),
    receiptDate: Yup.object().shape({
      day: Yup.number().required(),
      month: Yup.number().required(),
      year: Yup.number().required(),
    }),
    price: Yup.number().required(),
  })

export const linkPaymentValidation = () =>
  Yup.object().shape({
    mobile: Yup.string().required(),

    price: Yup.number().required(),
  })

export const nationalCodeValidation = () =>
  Yup.object().shape({
    nationalCode: Yup.string()
      .matches(NationalCodeRegex, "کد ملی معتبر نیست")
      .required("اجباری است"),
  })

export const discountPercentage = (amount) =>
  Yup.object().shape({
    percent: Yup.number()
      .moreThan(0, "مقدار باید بیشتر از صفر باشد")
      .max(amount, `مقدار نباید بیشتر از ${amount} درصد باشد`)
      .required("این فیلد اجباری است"),
    percentType: Yup.object({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
  })

export const rejectFishValidation = () =>
  Yup.object().shape({
    description: Yup.string().required(),
  })


export  const internalOrderValidationSchema = ()=>Yup.object().shape({
  senderHub: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
  }),
  receiverHub: Yup.object().shape({
    id: Yup.number().required(),
    text: Yup.string().required()
  }),
  consignmentType: Yup.object().shape({
    id: Yup.number().required(),
    text: Yup.string().required()
  }),
  contentType: Yup.object().shape({
    id: Yup.number().required(),
    text: Yup.string().required()
  }),
  content: Yup.string().nullable(),
  otherContent: Yup.string(),
  cprNumber: Yup.string()
    .required()
    .test('is-valid-cpr', 'شماره CPR باید 13 رقم باشد', value => 
      value && value.length === 13
    ),
  weight: Yup.number()
    .min(0, "وزن نمی‌تواند منفی باشد")
    .max(30, "حداکثر وزن 30 کیلوگرم است")
    .required("وزن الزامی است"),
  cardboardSize: Yup.object().shape({
    id: Yup.string().required("سایز کارتن الزامی است"),
    text: Yup.string().required("سایز کارتن الزامی است")
  }),
  length: Yup.number()
    .min(1, "طول باید بیشتر از 0 باشد")
    .required("طول الزامی است"),
  width: Yup.number()
    .min(1, "عرض باید بیشتر از 0 باشد")
    .required("عرض الزامی است"),
  height: Yup.number()
    .min(1, "ارتفاع باید بیشتر از 0 باشد")
    .required("ارتفاع الزامی است"),
  // comments: Yup.string(),
  orderId: Yup.string(),
  consignmentId: Yup.string(),

  comments:Yup.string().min(10).required()
  // ReciverName: Yup.string().required("نام گیرنده الزامی است"),

});
 export const sharePercentageSchema = Yup.object().shape({
  // hub: Yup.object({
  //   text: Yup.string().required('انتخاب هاب الزامی است'),
  //   id: Yup.string().required(),
  // }),
  validFrom: Yup.object().shape({
    day: Yup.number().required('روز الزامی است'),
    month: Yup.number().required('ماه الزامی است'),
    year: Yup.number().required('سال الزامی است'),
  }),
  validTo: Yup.object().shape({
    day: Yup.number().required('روز الزامی است'),
    month: Yup.number().required('ماه الزامی است'),
    year: Yup.number().required('سال الزامی است'),
  }),
  type: Yup.object({
    text: Yup.string().required('نوع محاسبه الزامی است'),
    id: Yup.string().required(),
  }),
  defaultPercentage: Yup.number().when('type', {
    is: (type) => [0, 1, 2].includes(type?.id),
    then: Yup.number()
      .required('درصد پیش فرض الزامی است')
      .min(0, 'درصد نمی‌تواند منفی باشد')
      .max(100, 'درصد نمی‌تواند بیشتر از ۱۰۰ باشد'),
  }),
})
export const sharePercentageTableSchema = Yup.object().shape({
  from: Yup.number()
    .nullable()
    .when('type', {
      is: (type) => [0, 3].includes(type?.id),
      then: Yup.number()
        .required('مقدار "از" الزامی است')
        .min(0, 'مقدار "از" نمی‌تواند منفی باشد'),
      // otherwise: Yup.mixed().notRequired(),
    }),

  to: Yup.number()
    .required('مقدار "تا" الزامی است')
    .when('from', (from, schema) => {
      return from !== undefined && from !== null
        ? schema.min(from, 'مقدار "تا" باید بزرگتر یا مساوی "از" باشد')
        : schema
    }),

  percentage: Yup.number()
    .required('درصد الزامی است')
    .min(0, 'درصد نمی‌تواند منفی باشد')
    .max(100, 'درصد نمی‌تواند بیشتر از ۱۰۰ باشد'),
})



export const defineCapacitySchema =(isEdit)=> Yup.object().shape({
  city :!isEdit && Yup.array()
      .min(1, "حداقل یک شهر باید انتخاب شود")
      .required("انتخاب شهر الزامی است"),
  safetyStock: Yup.number()
    .required()
    .min(0, 'ظرفیت احتیاطی نمی‌تواند صفر یا مکم تر از صفر باشد'),
  capacity: Yup.number()
    .required()
    .min(0, 'ظرفیت  نمی‌تواند صفر یا کم تر از صفر باشد'),
    customer: Yup.object().shape({
    id: Yup.number().required(),
    text: Yup.string().required()
  }),

})


  export const desorganizationValidation = () =>
  Yup.object().shape({
    anomalyDetectionHubId: Yup.object()
      .shape({
        text: Yup.string().required().label("هاب دریافت کننده"),
        id: Yup.string().required(),
      })
      .required()
      .label("هاب دریافت کننده"),

    requestType: Yup.object()
      .shape({
        text: Yup.string().required().label("نوع درخواست"),
        id: Yup.string().required(),
      })
      .required()
      .label("نوع درخواست"),

    reasonIdList: Yup.array()
      .of(
        Yup.object().shape({
          text: Yup.string().required(),
          id: Yup.number().required(),
        })
      )
      .min(1, "حداقل یک دلیل باید انتخاب شود")
      .required()
      .label("دلیل بی ترتیبی"),

    tripNo: Yup.string().when("requestType", {
      is: (requestType: any) => requestType?.id === "0",
      then: (schema) => schema.required().label("شماره سفر"),
      otherwise: (schema) => schema.notRequired(),
    }),
    bagNumber: Yup.string().when("requestType", {
      is: (requestType: any) => requestType?.id === "1",
      then: (schema) => schema.required().label("شماره کیسه"),
      otherwise: (schema) => schema.notRequired(),
    }),

   
    // bagNumber: Yup.string().when("reasonIdList", {
    //   is: (reasonIdList: any[]) => reasonIdList?.some((item) => item.id === 2),
    //   then: (schema) => schema.required().label("شماره کیسه"),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
    weight: Yup.string().when("reasonIdList", {
      is: (reasonIdList: any[]) => reasonIdList?.some((item) => item.id === 4),
      then: (schema) => schema.required().label(""),
      otherwise: (schema) => schema.notRequired(),
    }),
    packageId: Yup.string().when("reasonIdList", {
      is: (reasonIdList: any[]) => reasonIdList?.some((item) => item.id === 22),
      then: (schema) => Yup.object()
      .shape({
        text: Yup.string().required(),
        id: Yup.string().required(),
      }),
      otherwise: (schema) => schema.notRequired(),
    }),


    description: Yup.string().required(),

    isActive: Yup.boolean().notRequired(),
  });

  export const dissApprovalValidation = () =>
  Yup.object().shape({
    disApprovalDescription: Yup.string().required(),
  })





export const questionBankValidation = () =>
  Yup.object().shape({
    title: Yup.string().required(),
    
    validFrom: Yup.object().shape({
      day: Yup.number().required(),
      month: Yup.number().required(),
      year: Yup.number().required(),
    }),
    
    validTo: Yup.object().shape({
      day: Yup.number().required(),
      month: Yup.number().required(),
      year: Yup.number().required(),
    }),
    
    questionType: Yup.object().shape({
      id: Yup.number().required(),
      text: Yup.string().required(),
    }),
    
    questionAssessmentMethod: Yup.object().shape({
      id: Yup.number().required(),
      text: Yup.string().required(),
    }),
    
    selectReplyType: Yup.object().shape({
      id: Yup.number().required(),
      text: Yup.string().required(),
    }),
    
    // questioncontentList: Yup.array()
    //   .min(1, "حداقل یک پاسخ باید وارد شود")
    //   .required("وارد کردن لیست پاسخ‌ها الزامی است")
    //   .of(
    //     Yup.object().shape({
    //       priority: Yup.number().required(),
    //       title: Yup.string().required(),
    //     })
    //   ),
  });




  export const surveyValidation = () =>
  Yup.object().shape({
    title: Yup.string().required(),
    
    validFrom: Yup.object().shape({
      day: Yup.number().required(),
      month: Yup.number().required(),
      year: Yup.number().required(),
    }),
    
    validTo: Yup.object().shape({
      day: Yup.number().required(),
      month: Yup.number().required(),
      year: Yup.number().required(),
    }),
    
    // questionType: Yup.object().shape({
    //   id: Yup.number().required(),
    //   text: Yup.string().required(),
    // }),
    
    surveyType: Yup.object().shape({
      id: Yup.number().required(),
      text: Yup.string().required(),
    }),
  })

    
 
  export const smsSettingValidation = () =>
  Yup.object().shape({

    shiftPeriodId: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    smsSettingType: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    date:Yup.object().shape({
      day: Yup.number().required('روز الزامی است'),
      month: Yup.number().required('ماه الزامی است'),
      year: Yup.number().required('سال الزامی است'),
    }),

  })




const passportReg = /^[A-Z]{1,2}\d{8}$/;

export const identityOrderFromValidation = () =>
  Yup.object({
    receiver: Yup.object()
      .shape({
        name: Yup.string()
          .trim()
          .min(2)
          .matches(SpecialCharacter, NOTTYPE)
          .required(),
        mobile: Yup.string().matches(mobileReg, NOTTYPE).required(),
        receiverCityId: Yup.object().shape({
          text: Yup.string().required(),
          id: Yup.string().required(),
        }),
        address: Yup.string()
          .trim()
          .min(20)
          .matches(SpecialCharacter, NOTTYPE)
          .required(),

       amayeshCode: Yup.string()
        .nullable()
        .transform((value) => (value === "" ? null : value))
        .test(
          "len",
          "کد آمایش باید دقیقاً ۱۰ رقم باشد",
          (value) => !value || /^\d{10}$/.test(value)
        ),

        passportCode: Yup.string()
          .nullable()
          .transform((value) => (value === "" ? null : value))
          .matches(passportReg, {
            message:
              "۹ کاراکتر و شامل ۱ یا ۲ حرف بزرگ انگلیسی",
            excludeEmptyString: true,
          }),
      })
      .test(
        "identity-conflict",
        "امکان وارد کردن هم‌زمان کد آمایش و شماره گذرنامه وجود ندارد",
        function (value) {
          const { amayeshCode, passportCode } = value || {};

  
          if (amayeshCode && passportCode) {
            return this.createError({
              path: `${this.path}.passportCode`,
              message:
                "به صورت هم‌زمان کد آمایش و کد گذرنامه نمی‌تواند پر شود",
            });
          }

    
          if (!amayeshCode && !passportCode) {
            return this.createError({
              path: `${this.path}.amayeshCode`,
              message: "وارد کردن کد آمایش یا شماره گذرنامه الزامی است",
            });
          }

          return true;
        }
      ),
  });
